import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { ChevronRight, Users } from "lucide-react";
import { adminApi } from "../lib/api";
import { useAdminAuth } from "../lib/auth";
import { PageHeader } from "../components/layout";

function formatDate(value: string | null) {
  if (!value) return "нет запусков";
  return new Intl.DateTimeFormat("ru-RU", {
    dateStyle: "short",
    timeStyle: "short",
  }).format(new Date(value));
}

export function AccountsPage() {
  const { token } = useAdminAuth();
  const accounts = useQuery({
    queryKey: ["admin", "accounts"],
    queryFn: () => adminApi.accounts(token!),
    enabled: Boolean(token),
  });

  if (accounts.isLoading) {
    return <div className="panel p-4 text-sm text-muted-foreground">Загружаем аккаунты...</div>;
  }

  if (accounts.error) {
    return <div className="panel p-4 text-sm text-danger">{accounts.error.message}</div>;
  }

  return (
    <div>
      <PageHeader
        title="Клиенты"
        description="Все amoCRM-аккаунты, пользователи, агенты и последние запуски пайплайна."
      />

      <div className="space-y-2">
        {(accounts.data ?? []).map((account) => (
          <Link
            key={account.id}
            className="panel block p-4 transition-colors hover:border-primary/40 hover:bg-accent/40"
            to={`/accounts/${account.id}`}
          >
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
              <div className="min-w-0 flex-1">
                <p className="truncate text-base font-semibold">{account.amoAccountId}</p>
                <p className="mt-1 truncate text-sm text-muted-foreground">
                  {account.user?.email ?? "Пользователь не привязан"}
                </p>
              </div>

              <div className="grid min-w-0 grid-cols-2 gap-2 text-sm sm:w-[560px] sm:grid-cols-4">
                <div>
                  <p className="text-muted-foreground">Тариф</p>
                  <p className="font-medium">{account.plan}</p>
                </div>
                <div>
                  <p className="text-muted-foreground">Агенты</p>
                  <p className="font-medium">{account.funnelsCount}</p>
                </div>
                <div>
                  <p className="text-muted-foreground">Диалоги</p>
                  <p className="font-medium">{account.dialogsUsed}</p>
                </div>
                <div>
                  <p className="text-muted-foreground">Последний run</p>
                  <p className="font-medium">{formatDate(account.lastRunAt)}</p>
                </div>
              </div>

              <ChevronRight className="hidden h-5 w-5 shrink-0 text-muted-foreground sm:block" />
            </div>
          </Link>
        ))}
      </div>

      {accounts.data?.length === 0 ? (
        <div className="panel mt-4 flex items-center gap-3 p-4 text-sm text-muted-foreground">
          <Users className="h-5 w-5" />
          Аккаунтов пока нет.
        </div>
      ) : null}
    </div>
  );
}
